import React, {useEffect, useState} from 'react';
import classes from "./challenge.module.css";
import Info from "./info";
import {Base64} from "js-base64";
import {getChallengeReferralsAPI} from "../api";
import {useTelegram} from "../../../../hooks/useTelegram";

const FlipUnit = ({ unit, value }) => {
    const [prevValue, setPrevValue] = useState(value);

    useEffect(() => {
        if (value !== prevValue) {
            setPrevValue(value);
        }
    }, [value, prevValue]);

    return (
        <div className={classes.flipUnit}>
            <div className={classes.flipLabel}>{unit}</div>
            <div className={classes.flipContainer}>
                <div className={classes.flipCard}>
                    {/* Передняя сторона карточки – предыдущие значение */}
                    <div className={classes.cardFace+' '+classes.front}>
                        {prevValue}
                    </div>
                </div>
            </div>
        </div>
    );
};

const Challenge = ({client, getClient}) => {
    const {user} = useTelegram()
    const [openInfo, setOpenInfo] = useState(false)
    const [notification, setNotification] = useState(null)
    const [step, setStep] = useState(0)
    const [table, setTable] = useState([])
    const [selectUser, setSelectUser] = useState({})

    // Функция для расчёта оставшегося времени
    const calculateTimeLeft = () => {
        const now = new Date();
        let targetDate = new Date(2025, 8, 1, 0, 0, 0);
        let difference = targetDate - now;
        if (difference < 0){
            targetDate = new Date(2025, 9, 1, 0, 0, 0);
            difference = targetDate - now;
            setStep(1)
        }
        let timeLeft = {};

        if (difference > 0) {
            timeLeft = {
                'дней': Math.floor(difference / (1000 * 60 * 60 * 24)),
                'часов': Math.floor((difference / (1000 * 60 * 60)) % 24),
                'минут': Math.floor((difference / (1000 * 60)) % 60),
                'секунд': Math.floor((difference / 1000) % 60)
            };
        }else{
            setStep(2)
        }

        return timeLeft;
    };

    const [timeLeft, setTimeLeft] = useState('');

    useEffect(() => {
        // Обновляем таймер каждую секунду
        const timer = setInterval(() => {
            setTimeLeft(calculateTimeLeft());
        }, 1000);

        // Очистка интервала при размонтировании компонента
        return () => clearInterval(timer);
    }, []);

    useEffect(()=>{
        const getTable = async ()=>{
            const res = await getChallengeReferralsAPI();
            setTable(res)
            function findIndexByTelegramId(telegramId, array) {
                return  array.findIndex(item => item.telegram_id === telegramId);
            }
            let number = findIndexByTelegramId(client?.telegram_id, res);
            if(number === -1){
                setSelectUser({
                    number: res.length+1,
                    telegram_name: user?.first_name+' '+user?.last_name,
                    telegram_avatar: user?.photo_url,
                    count_refs: 0
                })
            }else{
                setSelectUser({
                    number: number+1,
                    telegram_name: user?.first_name+' '+user?.last_name,
                    telegram_avatar: user?.photo_url,
                    count_refs: res[number].count_active_refs
                })
            }
        }
        getTable()
    },[client])


    const shareLink = () => {
        let text = `https://t.me/EasyFastVPNBot?start=${Base64.encode(client.telegram_id)}`
        let textAreaValue = '🔥 Я пользуюсь этим VPN, советую и тебе попробовать!'
        window.open(
            `https://t.me/share/url?url=${text}&text=${textAreaValue}`
        );
    };

    const copyLink = () => {
        let text = `https://t.me/EasyFastVPNBot?start=${Base64.encode(client.telegram_id)}`
        navigator.clipboard.writeText(text);
        setNotification('Ссылка скопирована');
        setTimeout(() => setNotification(null), 2000);
    }

    return (
        <div className={classes._}>
            <div className={classes.headerText}>Конкурс</div>
            <div className={classes.headerText2}>У нас стартует конкурс для самых активных! Приглашайте друзей в наш VPN-сервис и получайте крупные денежные призы.<br/>
                <div>📅 Сроки: 1 сентября 00:00 - 30 сентября 23:59 (по МСК).</div>
                <div>💰 Призовой фонд:</div>
                <div>🥇 1 место: 10 000 ₽ <br/>
                    🥈 2 место: 5 000 ₽<br/>
                    🥉 3 место: 3 000 ₽</div>
                <div>А также 1-5 место получат безлимитный VPN навсегда, а 6-10 место - годовую подписку!</div>
                <div className={classes.link} onClick={()=>setOpenInfo(true)}>Вся информация по конкурсу</div>
                <div className={classes.buttonBlock}>
                    {!!notification && <div className={classes.notification}>{notification}</div>}
                    <div className={classes.button} onClick={shareLink}>Пригласить друга</div>
                    <div className={classes.buttonCopy} onClick={copyLink}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="20" viewBox="0 0 18 20" fill="none">
                            <path d="M3.9998 4V1C3.9998 0.44772 4.44752 0 4.9998 0H16.9998C17.5521 0 17.9998 0.44772 17.9998 1V15C17.9998 15.5523 17.5521 16 16.9998 16H13.9998V18.9991C13.9998 19.5519 13.5499 20 12.993 20H1.00666C0.45059 20 0 19.5554 0 18.9991L0.00259995 5.00087C0.00269995 4.44811 0.45264 4 1.00942 4H3.9998ZM2.00242 6L2.00019 18H11.9998V6H2.00242ZM5.9998 4H13.9998V14H15.9998V2H5.9998V4Z" fill="#FFF"/>
                        </svg>
                    </div>
                </div>
                <div className={classes.block}>
                    {step === 0 && <div>До начала конкурса</div>}
                    {step === 1 && <div>До окончания конкурса</div>}
                    {step === 2 && <div>Конкурс завершен!</div>}
                    <div style={{ display: 'flex', gap: '15px' }}>
                        {Object.keys(timeLeft).map((unit) => (
                            <FlipUnit key={unit} unit={unit} value={timeLeft[unit]} />
                        ))}
                    </div>
                </div>
                <div className={classes.tableBlock}>
                    <table className={classes.table}>
                        <tr>
                            <td className={classes.tableItem}>Место</td>
                            <td className={classes.tableItem2}>Пользователь</td>
                            <td className={classes.tableItem}>Пригласил</td>
                            <td className={classes.tableItem}>Приз</td>
                        </tr>
                        {table.length > 0 && <tr style={selectUser.number === 1 ? {background:'#555'}:{}}>
                            <td className={classes.tableItem}>🥇</td>
                            <td className={classes.tableItem2}>
                                {table[0].telegram_avatar && <img alt={''} src={table[0].telegram_avatar} className={classes.tableImage}/>}
                                {table[0].telegram_name}
                            </td>
                            <td className={classes.tableItem}>{table[0].count_active_refs}</td>
                            <td className={classes.tableItem}>10000₽</td>
                        </tr>}
                        {table.length > 1 && <tr style={selectUser.number === 2 ? {background:'#555'}:{}}>
                            <td className={classes.tableItem}>🥈</td>
                            <td className={classes.tableItem2}>
                                {table[1].telegram_avatar && <img alt={''} src={table[1].telegram_avatar} className={classes.tableImage}/>}
                                {table[1].telegram_name}
                            </td>
                            <td className={classes.tableItem}>{table[1].count_active_refs}</td>
                            <td className={classes.tableItem}>5000₽</td>
                        </tr>}
                        {table.length > 2 && <tr style={selectUser.number === 3 ? {background:'#555'}:{}}>
                            <td className={classes.tableItem}>🥉</td>
                            <td className={classes.tableItem2}>
                                {table[2].telegram_avatar && <img alt={''} src={table[2].telegram_avatar} className={classes.tableImage}/>}
                                {table[2].telegram_name}
                            </td>
                            <td className={classes.tableItem}>{table[2].count_active_refs}</td>
                            <td className={classes.tableItem}>3000₽</td>
                        </tr>}
                        {table.length > 3 && <tr style={selectUser.number === 4 ? {background:'#555'}:{}}>
                            <td className={classes.tableItem}>4</td>
                            <td className={classes.tableItem2}>
                                {table[3].telegram_avatar && <img alt={''} src={table[3].telegram_avatar} className={classes.tableImage}/>}
                                {table[3].telegram_name}
                            </td>
                            <td className={classes.tableItem}>{table[3].count_active_refs}</td>
                            <td className={classes.tableItem}>безлимит</td>
                        </tr>}
                        {table.length > 4 && <tr style={selectUser.number === 5 ? {background:'#555'}:{}}>
                            <td className={classes.tableItem}>5</td>
                            <td className={classes.tableItem2}>
                                {table[4].telegram_avatar && <img alt={''} src={table[4].telegram_avatar} className={classes.tableImage}/>}
                                {table[4].telegram_name}
                            </td>
                            <td className={classes.tableItem}>{table[4].count_active_refs}</td>
                            <td className={classes.tableItem}>безлимит</td>
                        </tr>}
                        {table.length > 5 && <tr style={selectUser.number === 6 ? {background:'#555'}:{}}>
                            <td className={classes.tableItem}>6</td>
                            <td className={classes.tableItem2}>
                                {table[5].telegram_avatar && <img alt={''} src={table[5].telegram_avatar} className={classes.tableImage}/>}
                                {table[5].telegram_name}
                            </td>
                            <td className={classes.tableItem}>{table[5].count_active_refs}</td>
                            <td className={classes.tableItem}>год</td>
                        </tr>}
                        {table.length > 6 && <tr style={selectUser.number === 7 ? {background:'#555'}:{}}>
                            <td className={classes.tableItem}>7</td>
                            <td className={classes.tableItem2}>
                                {table[6].telegram_avatar && <img alt={''} src={table[6].telegram_avatar} className={classes.tableImage}/>}
                                {table[6].telegram_name}
                            </td>
                            <td className={classes.tableItem}>{table[6].count_active_refs}</td>
                            <td className={classes.tableItem}>год</td>
                        </tr>}
                        {table.length > 7 && <tr style={selectUser.number === 8 ? {background:'#555'}:{}}>
                            <td className={classes.tableItem}>8</td>
                            <td className={classes.tableItem2}>
                                {table[7].telegram_avatar && <img alt={''} src={table[7].telegram_avatar} className={classes.tableImage}/>}
                                {table[7].telegram_name}
                            </td>
                            <td className={classes.tableItem}>{table[7].count_active_refs}</td>
                            <td className={classes.tableItem}>год</td>
                        </tr>}
                        {table.length > 8 && <tr style={selectUser.number === 9 ? {background:'#555'}:{}}>
                            <td className={classes.tableItem}>9</td>
                            <td className={classes.tableItem2}>
                                {table[8].telegram_avatar && <img alt={''} src={table[8].telegram_avatar} className={classes.tableImage}/>}
                                {table[8].telegram_name}
                            </td>
                            <td className={classes.tableItem}>{table[8].count_active_refs}</td>
                            <td className={classes.tableItem}>год</td>
                        </tr>}
                        {table.length > 9 && <tr style={selectUser.number === 10 ? {background:'#555'}:{}}>
                            <td className={classes.tableItem}>10</td>
                            <td className={classes.tableItem2}>
                                {table[9].telegram_avatar && <img alt={''} src={table[9].telegram_avatar} className={classes.tableImage}/>}
                                {table[9].telegram_name}
                            </td>
                            <td className={classes.tableItem}>{table[9].count_active_refs}</td>
                            <td className={classes.tableItem}>год</td>
                        </tr>}
                        {selectUser.number > 10 && <tr style={{background:'#555'}}>
                            <td className={classes.tableItem}>{selectUser.number}</td>
                            <td className={classes.tableItem2}>
                                {selectUser.telegram_avatar && <img alt={''} src={selectUser.telegram_avatar} className={classes.tableImage}/>}
                                {selectUser.telegram_name}
                            </td>
                            <td className={classes.tableItem}>{selectUser.count_active_refs}</td>
                            <td className={classes.tableItem}></td>
                        </tr>}
                    </table>
                </div>
                <Info isOpen={openInfo} setIsOpen={setOpenInfo}/>
            </div>
        </div>
    );
};

export default Challenge;